import React, { Component } from 'react';
import styled from 'styled-components'
import { Button, Tree, Card, Input, Form, Select } from 'antd'
import { apiUtil as Util } from '../../mock/mockServices';

const { TreeNode } = Tree;
const { Option } = Select

let params = new URLSearchParams(window.location.search);
let privilegeId = params.get('id');

const formItemLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 20
    }
};

class PrivilegeMgrComponent extends Component {

    state = {
        id: privilegeId,
        pName: '',
        pPath: '',
        pDesc: '',
        pResId: '',
        pStatus: '',
        checkedKeys: [],
        menuTreeData: [],
        keyWords: '',
        sorter: {},
        pagination: {
            current: 1,
            pageSize: 9999,
            showTotal: total => `${total} items `,
            total: 0
        },
    }

    componentDidMount() {
        if (privilegeId !== "0" && privilegeId !== null && privilegeId !== "null") {
            Util.ajax.get('/admin/getPrivilegeById', {
                id: privilegeId
            }).then(res => {
                const { data } = res
                if (!data) {
                    return false
                }
                const { pName, pPath, pDesc, pResId, pStatus } = data

                this.setState({
                    id: privilegeId,
                    pName: pName ? pName : '',
                    pPath: pPath ? pPath : '',
                    pDesc: pDesc ? pDesc : '',
                    pResId: pResId ? pResId : '',
                    pStatus: pStatus ? pStatus : '',
                    checkedKeys: pResId ? pResId.split(",") : [],
                }, () => {
                    this.props.form.setFieldsValue({
                        pName: this.state.pName,
                        pPath: this.state.pPath,
                        pDesc: this.state.pDesc,
                        pResId: this.state.pResId,
                        pStatus: this.state.pStatus,
                        checkedKeys: this.state.checkedKeys,
                    });
                })

            })
        }

        const { pagination, keyWords } = this.state

        Util.ajax.get('/admin/filterMenuList', {
            keyWords: keyWords,
            current: pagination.current,
            pageSize: pagination.pageSize
        }).then(res => {
            pagination.total = res.data.total
            if (pagination.total > 0) {
                this.setState({
                    menuTreeData: Util.transformData(Util.arrayToTree(res.data.list)),
                    pagination,
                })
            }
        })
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, value) => {
            if (!err) {
                console.log(value)
                value.pResId = this.state.pResId;

                if (privilegeId !== "0") {
                    Util.ajax.post('/admin/createPrivilege', value).then(res => {
                        Util.message.success('Saved successfully')
                        window.close();
                    })
                } else {
                    Util.ajax.post('/admin/editPrivilege', value).then(res => {
                        Util.message.success('Saved successfully')
                        window.close();
                    })
                }
            }
        });
    }


    onCheck = (checkedKeys, info) => {
        let interactedKeys = info.node.props.eventKey;

        let interactedChildrenKeys = [];
        const getChildrenKeys = (node) => {
            if (node.props.children) {
                for (let child of node.props.children) {
                    interactedChildrenKeys.push(child.key);
                    getChildrenKeys(child);
                }
            }
        }
        getChildrenKeys(info.node);

        let finalCheckedKeys;

        if (checkedKeys.checked.includes(interactedKeys)) {
            finalCheckedKeys = [...new Set([...checkedKeys.checked, ...interactedChildrenKeys])];
        } else {
            finalCheckedKeys = checkedKeys.checked.filter(key => !interactedChildrenKeys.includes(key));
        }

        this.setState({ checkedKeys: finalCheckedKeys, pResId: finalCheckedKeys.join(",") });
    };

    renderTreeNodes = data =>
        data.map(item => {
            if (item.children) {
                return (
                    <TreeNode title={item.title} key={item.key} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.key} {...item} />;
        });

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="horizontal" {...formItemLayout} style={{ width: '660px' }} onSubmit={this.handleOk}>
                <Form.Item label="Privilege Name">
                    {getFieldDecorator('pName', {
                        initialValue: this.state.pName,
                        rules: [
                            { required: true, message: 'Please enter the privilege name', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Privilege Path">
                    {getFieldDecorator('pPath', {
                        initialValue: this.state.pPath,
                        rules: [
                            { required: true, message: 'Please enter the privilege path', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Privilege Description">
                    {getFieldDecorator('pDesc', {
                        initialValue: this.state.pDesc,
                        rules: [
                            { required: true, message: 'Please enter the privilege description', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Privilege Status">
                    {getFieldDecorator('pStatus', {
                        initialValue: this.state.pStatus ? this.state.pStatus : '1',
                        rules: [
                            { required: true, message: 'Please enter the privilege status', whitespace: true },
                        ]
                    })(<Select onChange={value => this.props.form.setFieldsValue({ type: value })}>
                        <Option value='0'>Disabled</Option>
                        <Option value='1'>Enabled</Option>
                    </Select>)}
                </Form.Item>
                <Form.Item label="Associated Menu">
                    <Tree
                        checkable
                        onCheck={this.onCheck}
                        checkedKeys={this.state.checkedKeys}
                        checkStrictly={true}
                        treeDefaultExpandAll
                    >
                        {this.renderTreeNodes(this.state.menuTreeData)}
                    </Tree>
                </Form.Item>
                <Form.Item label="" wrapperCol={{ push: 4 }}>
                    <Button className="mr20" onClick={this.handleTest}>Clear</Button>
                    <Button type="primary" onClick={this.handleSubmit}>Save</Button>
                </Form.Item>
            </Form>
        )
    }
}

const PrivilegeMgrForm = Form.create({ name: 'dw-config-form' })(PrivilegeMgrComponent)

export default class PrivilegeMgr extends Component {

    render() {
        const isNew = privilegeId === "0" || privilegeId === null || privilegeId === "null";
        return (
            <Root>
                <div className="page-content">
                    <Card title={
                        <div style={{ fontSize: '22px', fontWeight: 'bold' }}>Privilege Management</div>
                    } bordered={false} style={{ width: '100%' }}>
                        {/* <div className="title"></div>
                        <Divider></Divider> */}
                        <div className="sub-title">
                            {isNew ? (
                                <div>Add Privilege</div>
                            ) : (
                                <div>Edit Privilege (id: {privilegeId})</div>
                            )}
                        </div>
                        <PrivilegeMgrForm></PrivilegeMgrForm>
                    </Card>
                </div>
            </Root>

        )
    }
}

const Root = styled.div`
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .sub-title{
        font-size:18px;
        font-weight: bold;
        padding: 5px 0 15px;
    }
`